import { createContext } from 'react';

import { UserRoles } from '@/lib/constants/auth.constants.ts';
import { OneRosterUser } from '@/types/user.oneroster';

export interface OneRosterAuth {
  user: OneRosterUser | null;
  isAuthenticated: boolean;
  roles: UserRoles[];
  isAdmin: boolean;
  isAide: boolean;
  isParent: boolean;
  isSysAdmin: boolean;
  isImpersonated: boolean;
  isLoading: boolean;
  error: Error | null;
  children: OneRosterUser[];
  hasRole: (role: UserRoles) => boolean;
}

export const AuthenticationContext = createContext<OneRosterAuth>({
  user: null,
  isAuthenticated: false,
  roles: [],
  isAdmin: false,
  isAide: false,
  isParent: false,
  isSysAdmin: false,
  isImpersonated: false,
  isLoading: false,
  error: null,
  children: [],
  hasRole: () => false,
});
